import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import withAuthGuard from '../withAuthGuard';
import withLoader from '../../components/withLoader';
import withPaymentStatus from '../withPaymentStatus';
import OrderSideComponent from '../OrderSideComponent';
import MyPaymentMethods from '../../components/MyPaymentMethods';
import withMembershipGuard from '../../containers/withMembershipGuard';
import withNoMembershipPurchased from '../../containers/withNoMembershipPurchased';

import { deleteCouponCode, requestAsync } from '../../queries/actions';
import {
  changeFavoritePaymentMethod,
  getPaymentMethodsByUser,
  NewPaymenthMethodsToUser
} from '../../queries/paymentMethods';
import { withSidecardWrapper } from '../../components/withSidecardWrapper';
import { selectUserData, selectUserPaymentMethods } from '../../queries/selectors/user';
import { getProductsToBuy, getSelectedPlan } from '../../queries/selectors/shoppingCart';
import { selectCouponApply, selectSingleSubscriptionClient, selectSubscriberConfig } from '../../queries/selectors/bootstrap';
import { selectAllSubPaymentMethodsConfig, selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import {selectActivePlanSubscription} from "../../queries/selectors/products";

const mapStateToProps = (state, props) => ({
  userData: selectUserData(state),
  productsToBuy: getProductsToBuy(state),
  subscriber: selectSubscriberConfig(state),
  couponApply: selectCouponApply(state),
  userPaymentMethods: selectUserPaymentMethods(state),
  currentPaymentMethod: selectCurrentPaymentMethod(state),
  isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
  subPaymentMethods: selectAllSubPaymentMethodsConfig(state),
  plan: getSelectedPlan(state),
  planSubscription: selectActivePlanSubscription(state),

  changeFavoriteUserPaymentMethod: (data) => requestAsync(changeFavoritePaymentMethod, data),
  newUserPaymentMethods: (data) => requestAsync(NewPaymenthMethodsToUser, data),
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    getPaymentMethodsByUser: (data) => requestAsync(getPaymentMethodsByUser, data),
    deleteCouponCode: payload => dispatch(deleteCouponCode(payload)),
  }, dispatch)
);

export default compose(
  injectIntl,
  withPaymentStatus,
  withNoMembershipPurchased,
  withMembershipGuard,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true }),
  withLoader(({ methods }) => methods && !methods.length),
  withSidecardWrapper({
    SideComponent: OrderSideComponent,
    texts: {
      title: <FormattedMessage id="PaymentMethodSelector.methods.dlocal.title" />
    },
    sideProps: {
      showSubPaymentMethods: true,
    }
  })
)(MyPaymentMethods);
